import { css } from "lit";
import constants from "../../../constants";

export const style = css`
	:host {
		padding: 0px;
		display: flex;
		flex-direction: column;
	}

	.body {
		flex: 1;
		overflow: hidden;
	}

	og-container, og-container rp-filter {
		height: 100%;
	}

	.controls {
		flex: 0 0 22px;
		display: flex;
		flex-direction: row;
	}

	.controls og-button {
		height: 100%;
		text-align: center;
		display: block;
		border-right: none;
		width: 20px;
	}

	.controls og-button.btn-primary {
		flex: 1;
	}

	.controls og-button.btn-secondary {
		flex: 0 0 19px;
		border-radius: 0;
	}

	.controls og-dropdown-menu {
		flex: 0 0 19px;
	}

	og-panel .header {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 5px;
	}

	.row {
		padding: ${constants.FILTER_PADDING}px ${constants.FILTER_PADDING}px 0 ${constants.FILTER_PADDING}px;
	}

	.row:last-child {
		padding-bottom: ${constants.FILTER_PADDING}px;
	}

	.row > * {
		width: 100%;
	}

	.row og-tree-dropdown, .row og-dropdown-list, .row og-dropdown-colorpicker {
		border: 1px solid var(--og-colortype-accent-border-color);
		background-color: var(--og-accent-color-alpha-30);
		color: var(--og-text-color-3);
	}

	.row og-input {
		border: 1px solid var(--og-colortype-accent-border-color);
		color: var(--og-text-color-3);
	}
`;
